var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.987 3.809A5.882 5.882 0 0 1 12 3c1.083 0 2.086.268 3.009.804a5.94 5.94 0 0 1 2.187 2.189A5.89 5.89 0 0 1 18 9.003c0 1.031-.258 2.01-.773 2.935l-4.893 8.877A.357.357 0 0 1 12 21a.357.357 0 0 1-.334-.185l-4.893-8.877C6.258 11.06 6 10.081 6 9.003a5.89 5.89 0 0 1 .804-3.01 5.916 5.916 0 0 1 2.183-2.184zm1.423 6.794c.44.433.97.65 1.59.65.62 0 1.15-.218 1.59-.655.44-.436.659-.968.659-1.595s-.218-1.159-.655-1.595A2.17 2.17 0 0 0 12 6.753a2.17 2.17 0 0 0-1.594.655 2.171 2.171 0 0 0-.655 1.595c0 .627.22 1.16.659 1.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a56099a713732f204960ca72def8126e.svg";
export { ForwardRef as ReactComponent };